module.exports = __webpack_public_path__ + "static/media/dst_logo.d6186eb9.webp";